import { useEffect, useRef } from 'react';
import { pushEvent, ANALYTICS_EVENTS } from '../utils/analytics'; // Assuming ANALYTICS_EVENTS contains UPGRADE_TO_PRO_SECTION_VIEWED

const useSectionObserver = (sectionRefs, eventName, options = { threshold: 0.5 }) => {
  const observerRef = useRef(null);
  const observedElements = useRef(new Set());

  useEffect(() => {
    if (observerRef.current) {
      observerRef.current.disconnect();
    }

    observerRef.current = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && entry.intersectionRatio >= options.threshold) {
          const sectionId = entry.target.dataset.sectionId;
          if (sectionId && !observedElements.current.has(sectionId)) {
            pushEvent({
              event: eventName,
              section_id: sectionId,
              page_path: window.location.pathname,
            });
            observedElements.current.add(sectionId);
            // Optionally, unobserve if you only want to track once per page load
            // observerRef.current.unobserve(entry.target); 
          }
        }
      });
    }, options);

    const currentObserver = observerRef.current;

    sectionRefs.forEach(refObject => {
      if (refObject && refObject.ref && refObject.ref.current && refObject.id) {
        // Add a data attribute to the element for easier identification
        refObject.ref.current.dataset.sectionId = refObject.id;
        currentObserver.observe(refObject.ref.current);
      }
    });

    return () => {
      if (currentObserver) {
        currentObserver.disconnect();
      }
      observedElements.current.clear();
    };
  }, [sectionRefs, eventName, options]);
};

export default useSectionObserver;
